import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Container, Box, Stack, Avatar, InputAdornment, IconButton } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PasswordChecklist from "react-password-checklist"
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { reset_password } from '../../api';
import { useDispatch } from 'react-redux';
import { setSnackDetails, setMetaData } from '../../service/actions/common';

const  Password = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [password, setPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    const [btnDisabled, setBtnDisabled] = useState(true);

    let { token } = useParams();
    const metaData  = {
      title: 'Set Password | InspectReply AI',
      description: 'Set Password | InspectReply AI'
    };
    const handleLoadPassword = async (e) => {
      e.preventDefault();
      try {
          console.log('Login:', { token, password });
          const { data } = await reset_password({ token, password });
          dispatch(setSnackDetails({openState : true, message : data.message, severity : 'success'}));
          navigate('/sign-in');
        } catch (error) {
          dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
          console.error(error);
        }
    };
    useEffect(() => {
        dispatch(setMetaData(metaData));
        // eslint-disable-next-line
    }, []);

  return (
    <Container maxWidth="xs">
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Avatar 
        alt="Logo" 
        src="/logo.png" 
        variant="rounded"
        sx={{
            height: 134,
            width: 134,
            maxHeight: { xs: 233, md: 167 },
            maxWidth: { xs: 350, md: 250 },
          }} />
       
        <Typography component="h1" variant="h5" sx={{ mt: 2}}>
          Set Password
        </Typography>

        <Typography component="p" sx={{ mt: 2 }}>
          pick something creative yet memorable
        </Typography>

        <Box component="form" onSubmit={handleLoadPassword} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            name="confirmPassword"
            id="confirmPassword"
            label="Password"
            type={showPassword ? "text" : "password"} // <-- This is where the magic happens
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            InputProps={{ 
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKeyIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

        <Typography component="h6" sx={{ mt: 2 }}>
            Password Requirements:
        </Typography>

        <PasswordChecklist
            rules={["minLength","specialChar","number","capital", "lowercase"]}
            minLength={8}
            value={password}
            onChange={(isValid) => {
              setBtnDisabled(!isValid);
            }}
        />

          <Stack direction="row" justifyContent="end" spacing={2} sx={{ mt: 2}}>        
            <Button
              disabled={btnDisabled}
              type="submit"
              variant="contained"
              sx={{ mt: 3, mb: 2, borderRadius: 28, ml: "auto" }}
            >
              Continue
            </Button>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};

export default Password;